import { Injectable } from '@angular/core';


export interface TimeDataType {
  values: number[];
  valueMap: { year: number, month: number }[];
  labels: string[];
}

@Injectable()
export class TimeService {

  data: Promise<TimeDataType>;
  current: { value: number, label: string, valueMap: { year: number, month: number } };
  graphYear: number;

  constructor() {
    this.data = new Promise<TimeDataType>((resolve, reject) => {
      this.promiseResolve = resolve;
    });
  }

  get() {
    return this.data;
  }

  promiseResolve(data: any) {

  }

  set(years: number[]) {
    const data_out: TimeDataType = { values: [], labels: [], valueMap: [] };
    let counter = 0;
    years.forEach(year => {
      for (let i = 1; i <= 12; i++) {
        data_out.values.push(counter);
        data_out.labels.push(i + '/' + year);
        data_out.valueMap.push({
          year: year,
          month: i
        });
        counter += 1;
      }
    });

    this.promiseResolve(data_out);
  }

}



// WEBPACK FOOTER //
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/services/time.service.ts